import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import orgAuthService from '../../../services/api/Organization/orgAuthService';
import AppSecureStorage from '../../../services/storage/secureStorage';
import { message } from 'antd';
import { setUserProfile, setUserType } from '../../Global/globalSlice';
// import { unauthorizedError } from '../../../utils/helpers';
import { get_all_Subscriptions_org, get_latest_Subscriptions_org } from '../OrganizationInfo/OrganizationSlice';
const orgAuth = new orgAuthService();
const storage = new AppSecureStorage();

export const org_signup = createAsyncThunk(
    "auth/org_signup",
    async ({ body, navigate }, { dispatch }) => {
        dispatch(setOrgSignupLoad(true))
        try {
            const response = await orgAuth.SignUp(body)
            dispatch(setUserType('organization'))
            storage.setItem('email', response.data.email)
            message.success(response.data.message)
            dispatch(setOrgSignupLoad(false));
            dispatch(setOrgSignupStep(1))
            return response.data
        } catch (error) {
            dispatch(setOrgSignupLoad(false))
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

export const org_login = createAsyncThunk(
    "auth/org_login",
    async ({ body, navigate }, { dispatch }) => {
        dispatch(setLoginLoading(true))
        try {
            const response = await orgAuth.login(body)
            const { data } = response;
            storage.setItem('token', data?.token)
            dispatch(setLoginLoading(false))
            navigate('/dashboard')
            dispatch(setUserType('organization'))
            storage.setItem('currentUser', 'organization')
            // dispatch(get_organization(navigate))
            message.success("Organization logged in successfully")
            return response.data
        } catch (error) {
            dispatch(setLoginLoading(false))
            const errorMsg = error?.response?.data?.error;
            if (errorMsg === "Organization is pending approval") {
                dispatch(setPendingApprovalModal(true));
            } else {
                error?.response?.data?.msg && message.error(error?.response?.data?.msg);
                error?.response?.data?.forEach?.((err) => {
                    message.error(`${err.msg} of ${err?.path}`);
                });
            }

        }
    }
);

export const get_organization = createAsyncThunk(
    "orgnization/get_organization",
    async (navigate, { dispatch }) => {
        try {
            const response = await orgAuth.GET_ORGANIZATION()
            const { data } = response;
            dispatch(setUserType('organization'))
            dispatch(setUserProfile(data))
            dispatch(get_all_Subscriptions_org(navigate))
            dispatch(get_latest_Subscriptions_org(navigate))
            return response.data
        } catch (error) {
            error?.response?.data?.error && message.error(error?.response?.data?.error);
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data;
                message.error(msg);
            // }
        }
    }
);

export const org_Google_Auth_Login = createAsyncThunk(
    "auth/Google_Auth_Login",
    async ({ body, navigate }, { dispatch }) => {
        dispatch(setOrgGoogleLoad(true))
        try {
            const response = await orgAuth.GoogleAuthLogin(body)
            storage.setItem('token', response.data?.token)
            message.success(response.data.message)
            if (response) {
                dispatch(setOrgGoogleLoad(false))
                navigate('/dashboard')
            }
            return response.data
        } catch (error) {
            dispatch(setOrgGoogleLoad(false))
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

export const send_password_reset_link_org = createAsyncThunk(
    "auth/send_password_reset_link_org",
    async ({ body, navigate }, { dispatch }) => {
        dispatch(setpasswordrestlinkloadorg(true))
        try {
            const response = await orgAuth.Send_reset_password_link_org(body)
            const { data } = response;
            message.success(data.msg)
            dispatch(setpasswordrestlinkloadorg(false))
            dispatch(setIsForgetPassOrg(false));
            dispatch(setIsNewPasswordorg(true))
            return response.data
        } catch (error) {
            dispatch(setpasswordrestlinkloadorg(false))
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

export const change_password_org = createAsyncThunk(
    "auth/change_password_org",
    async ({ body, navigate, isSignup }, { dispatch }) => {
        dispatch(setchangepasswordloadorg(true))
        try {
            const response = await orgAuth.Change_password_org(body)
            const { data } = response;
            message.success(data.msg)
            // storage.setItem('token', data?.token)
            dispatch(setchangepasswordloadorg(false))
            dispatch(setIsForgetPassOrg(false))
            dispatch(setIsNewPasswordorg(false))
            return response.data
        } catch (error) {
            dispatch(setIsNewPasswordorg(false))
            dispatch(setchangepasswordloadorg(false))
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

export const get_permissions = createAsyncThunk(
    "auth/get_permissions",
    async ({ navigate }, { dispatch }) => {
        dispatch(setPermissionLoad(true))
        try {
            const response = await orgAuth.Get_Permissions()
            const { data } = response;
            dispatch(setPermissionLoad(false))
            dispatch(setGetPermissions(data))
            return response.data
        } catch (error) {
            dispatch(setPermissionLoad(false))
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

export const add_representative_user = createAsyncThunk(
    "auth/add_representative_user",
    async ({ body, navigate }, { dispatch }) => {
        dispatch(setBindUserLoad(true))
        try {
            const response = await orgAuth.Add_Respresentative_User(body)
            dispatch(setBindUserLoad(false))
            message.success("Representative added successfully");
            return response.data
        } catch (error) {
            dispatch(setBindUserLoad(false))
            error?.response?.data?.message && message.error(error?.response?.data?.message)

        }
    }
);

export const get_bind_user = createAsyncThunk(
    "auth/get_bind_user",
    async ({ navigate }, { dispatch }) => {
        dispatch(setBindUserLoad(true))
        try {
            const response = await orgAuth.Get_Bind_User()
            const { data } = response;
            dispatch(setBindUserLoad(false))
            dispatch(setBindUsers(data))
            return response.data
        } catch (error) {
            dispatch(setBindUserLoad(false))
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

export const remove_bind_user = createAsyncThunk(
    "auth/remove_bind_user",
    async ({ navigate }, { dispatch }) => {
        dispatch(setBindUserLoad(true))
        try {
            const response = await orgAuth.Remove_Bind_User()
            const { data } = response;
            dispatch(setBindUserLoad(false))
            return response.data
        } catch (error) {
            dispatch(setBindUserLoad(false))
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

export const get_all_roles = createAsyncThunk(
    "auth/get_all_roles",
    async ({ navigate }, { dispatch }) => {
        dispatch(setRoleLoad(true))
        try {
            const response = await orgAuth.Get_Roles()
            const { data } = response;
            dispatch(setRoleLoad(false))
            dispatch(setAllRoles(data))
            return response.data
        } catch (error) {
            dispatch(setRoleLoad(false))
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

export const get_applications = createAsyncThunk(
    "auth/get_applications",
    async ({ applicationId, navigate }, { dispatch }) => {
        dispatch(setAppLoad(true))
        try {
            const response = await orgAuth.Get_applications(applicationId)
            const { data } = response;
            dispatch(setAppLoad(false))
            dispatch(setApplicationData(data))
            return response.data
        } catch (error) {
            dispatch(setAppLoad(false))
            error?.response?.data?.error && message.error(error?.response?.data?.error)
            const [{ msg }] = error.response.data
            message.error(msg)
        }
    }
);

const initialState = {
    orgUserDetails: {},
    orgSignupLoad: false,
    isOrgGenerateOtp: false,
    loading: false,
    isVerifySuccess: false,
    orgSignupStep: 0,
    orgUserValues: {},
    loginLoading: false,
    orgGoogleLoad: false,
    isForgetPassOrg: false,
    passresetlinkloadorg: false,
    passwordResetloadorg: false,
    isNewPasswordorg: false,
    permissions: [],
    bindUsers: [],
    bindUserLoad: false,
    permisionload: false,
    allRoles: [],
    roleLoad: false,
    applicationsData: [],
    appload: false,
    pendingApprovalModal: false,
};

const orgAuthSlice = createSlice({
    name: 'orgAuth',
    initialState,
    reducers: {
        setOrgSignupLoad: (state, action) => {
            state.orgSignupLoad = action.payload
        },
        setIsOrgGenerateOtp: (state, action) => {
            state.isOrgGenerateOtp = action.payload
        },
        setOrgSignupStep: (state, action) => {
            state.orgSignupStep = action.payload
        },
        setIsVrifySuccess: (state, action) => {
            state.isVerifySuccess = action.payload
        },
        setOrgUserValues: (state, action) => {
            state.orgUserValues = action.payload
        },
        setLoginLoading: (state, action) => {
            state.loginLoading = action.payload
        },
        setOrgGoogleLoad: (state, action) => {
            state.orgGoogleLoad = action.payload
        },
        setIsForgetPassOrg: (state, action) => {
            state.isForgetPassOrg = action.payload
        },
        setpasswordrestlinkloadorg: (state, action) => {
            state.passresetlinkloadorg = action.payload
        },
        setchangepasswordloadorg: (state, action) => {
            state.passwordResetloadorg = action.payload
        },
        setIsNewPasswordorg: (state, action) => {
            state.isNewPasswordorg = action.payload
        },
        setGetPermissions: (state, action) => {
            state.permissions = action.payload
        },
        setPermissionLoad: (state, action) => {
            state.permisionload = action.payload
        },
        setBindUsers: (state, action) => {
            state.bindUsers = action.payload
        },
        setBindUserLoad: (state, action) => {
            state.bindUserLoad = action.payload
        },
        setAllRoles: (state, action) => {
            state.allRoles = action.payload
        },
        setRoleLoad: (state, action) => {
            state.roleLoad = action.payload
        },
        setApplicationData: (state, action) => {
            state.applicationsData = action.payload
        },
        setAppLoad: (state, action) => {
            state.appload = action.payload
        },
        setPendingApprovalModal(state, action) {
            state.pendingApprovalModal = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(org_signup.pending, (state, action) => {
            state.loading = true;
        })
            .addCase(org_signup.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
            })
            .addCase(org_signup.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(org_login.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(org_login.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
            })
            .addCase(org_login.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(get_organization.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(get_organization.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
            })
            .addCase(get_organization.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export const
    { setOrgSignupLoad, setIsOrgGenerateOtp, setOrgSignupStep, setIsVrifySuccess,
        setOrgUserValues, setLoginLoading, setOrgGoogleLoad, setIsForgetPassOrg, setIsNewPasswordorg,
        setchangepasswordloadorg, setpasswordrestlinkloadorg, setGetPermissions, setPermissionLoad, setBindUserLoad
        , setBindUsers, setAllRoles, setRoleLoad, setApplicationData, setAppLoad, setPendingApprovalModal
    } = orgAuthSlice.actions;
export default orgAuthSlice.reducer;
